import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  children,
  className = '',
  onClick
}: CTAButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      window.open('https://zaelshop.com/cart/48405033648378:1', '_blank');
    }
  };
  return <button onClick={handleClick} className={`group relative inline-flex items-center justify-center gap-3 rounded-full bg-gradient-to-r from-amber-500 to-amber-600 px-8 py-4 text-lg font-bold text-white shadow-[0_0_30px_rgba(245,158,11,0.3)] transition-all duration-300 hover:scale-105 hover:from-amber-400 hover:to-amber-500 hover:shadow-[0_0_40px_rgba(245,158,11,0.5)] focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2 focus:ring-offset-[#0A0A0F] ${className}`} data-id="element-133">
      <span data-id="element-134">{children}</span>
      <ArrowRightIcon className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" data-id="element-135" />
    </button>;
}